import axios from '../axios'
import { logError } from '../../../shared'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import appConfig from '../../../app.config'

export async function getContactChangeStatus(customerId: string | undefined) {
	return axios
		.get<{
			canChangeContactInfo: boolean
			canChangeAddress: boolean
		}>(
			`${appConfig.customerDataBaseUrl}/api/User/${customerId}/contact/change/status`,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
